import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'gioDate'
})
export class GioDatePipe implements PipeTransform {

  transform(value: any, format: string = 'LLL', timezone?: string): any {
    let date = moment.isMoment(value) ? value : moment(value);
    if (timezone) {
      date = date.clone().tz(timezone);
    }
    return date.format(format);
  }

}
